import {
    PublicClientApplication,
    EventType,
    AuthenticationResult,
} from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID!,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AAD_TENANT_ID}`,
        redirectUri:
            process.env.REACT_APP_AAD_REDIRECT_URI || window.location.origin,
        postLogoutRedirectUri: '/login',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.addEventCallback((event) => {
    if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
            event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload
    ) {
        const authResult = event.payload as AuthenticationResult;
        if (authResult.account) {
            msalInstance.setActiveAccount(authResult.account);
        }
    }

    if (event.eventType === EventType.HANDLE_REDIRECT_END) {
        const acc =
            msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
        if (acc) msalInstance.setActiveAccount(acc);
    }
});

export const msalReady = msalInstance.initialize();
